import React from "react";
import { Typography } from "@mui/material";

const StandardLabel = ({
  labelText,
  fontSize = "x-small",
}) => {
  return (
    <Typography
      component="label"
      variant="subtitle2"
      fontSize={fontSize}
      color="text.secondary"
      sx={{ userSelect: "none" }}>
      {labelText}
    </Typography>
  );
};

export default StandardLabel;